export default "__VITE_ASSET__BLGmM4Mc__"